import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Heading, Paragraph } from '@digdir/designsystemet-react';
import { CheckmarkCircleIcon, PaperplaneIcon } from '@navikt/aksel-icons';
import type { ActionPlanChoices } from '../../logic/ActionPlanFlowManager';
import { ContributionLayout } from '../ContributionLayout/ContributionLayout';
import classes from './ActionPlanThankYou.module.css';

interface ActionPlanThankYouProps {
  /** Valgene fra steg 2. Mangler når brukeren kommer tilbake senere. */
  choices?: ActionPlanChoices;
  onBackToResults: () => void;
}

export const ActionPlanThankYou = ({ choices, onBackToResults }: ActionPlanThankYouProps) => {
  const { t } = useTranslation();
  const headingRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    headingRef.current?.focus({ preventScroll: true });
  }, []);

  return (
    <ContributionLayout>
      <section aria-labelledby="thank-you-heading" className={classes.card}>
        <span aria-hidden="true" className={classes.icon}>
          <CheckmarkCircleIcon />
        </span>
        <div className={classes.text}>
          <Heading id="thank-you-heading" ref={headingRef} tabIndex={-1} level={1} data-size="lg" className={classes.title}>
            {t('contribution.done.title')}
          </Heading>
          <Paragraph>{t('publicSurvey.actionPlan.thankYou.description')}</Paragraph>
        </div>
        {choices && (
          <dl className={classes.choices}>
            <div>
              <dt>{t('contribution.choose.commitment.title')}</dt>
              <dd>{choices.commitment}</dd>
            </div>
            <div>
              <dt>{t('contribution.choose.expectation.title')}</dt>
              <dd>{choices.expectation}</dd>
            </div>
          </dl>
        )}
        <div className={classes.next}>
          <PaperplaneIcon aria-hidden className={classes.nextIcon} />
          <Paragraph data-size="sm">{t('publicSurvey.actionPlan.thankYou.waitingInfo')}</Paragraph>
        </div>
        <Button onClick={onBackToResults}>{t('publicSurvey.actionPlan.thankYou.backToResults')}</Button>
      </section>
    </ContributionLayout>
  );
};
